import { Text, Button, Input, useToast, Flex, Spinner } from "@chakra-ui/react";
import { SyntheticEvent, useEffect, useState } from "react";
import { subscribeEmail } from "services";
import { validateEmail } from "utils";

const SubscribeEmail = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubscribing, setIsSubscribing] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (email) {
      const isValidEmail = validateEmail(email);

      if (isValidEmail) {
        setError("");
      } else {
        setError("Please enter correct email ID");
      }
    }
  }, [email]);

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setError("Please enter correct email ID");
      return;
    }

    setIsSubscribing(true);

    const formData: any = new FormData();
    formData.append("Email", email);

    //TODO: update this endpoint to subscribe
    const response = await subscribeEmail(formData);

    if ((response as any).error) {
      toast({
        description: "Failed to subscribe",
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
      setIsSubscribing(false);
      setEmail("");
      return;
    }

    toast({
      description: "Email subscribed successfully",
      status: "success",
      duration: 2000,
      position: "top",
      isClosable: true,
    });
    setIsSubscribing(false);
    setEmail("");
  };

  return (
    <Flex>
      <form onSubmit={handleSubmit}>
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          gap={4}
          width={{ base: "85vw", md: "568px" }}
          p={"10px"}
        >
          <Input
            bg="white"
            type="email"
            required
            placeholder="Email address"
            value={email}
            fontSize="1rem"
            fontWeight="500"
            h="48px"
            pl="1.5rem"
            pr="0"
            position={"relative"}
            onChange={(e) => setEmail(e.target.value)}
            _placeholder={{ color: "textSecondary" }}
            color="textSecondary"
            w={{ base: "calc(100% - 63px)", md: "489px" }}
            border="2px"
            borderColor="#EEEEEE"
            borderRadius="8px"
            _focus={{
              outline: 0,
              boxShadow: "0 0 0 0 rgba(0, 0, 0, 0)",
              border: "1px",
            }}
            _hover={{
              outline: 0,
              boxShadow: "0 0 0 0 rgba(0, 0, 0, 0)",
              border: "1px",
            }}
          />
          <Button
            type="submit"
            p={{ base: "10px 8px", md: "10px 28px" }}
            h="46px"
            bg="white"
            border="1px"
            borderColor="#D8F0F0"
            borderRadius="6px"
            w={"83px"}
            isDisabled={error as unknown as boolean}
          >
            {/* Subscribe */}
            {isSubscribing ? (
              <Spinner size="md" color="primary" />
            ) : (
              <Text color="textPrimary" fontSize="10px" fontWeight="500">
                Sign Up
              </Text>
            )}
          </Button>
        </Flex>

        {error && (
          <Flex pl={"10px"}>
            <Text fontSize="12px" color="#e53e3e" textAlign="left">
              {error}
            </Text>
          </Flex>
        )}
      </form>
    </Flex>
  );
};

export default SubscribeEmail;
